import {AnnouncementCategory, AnnouncementDto, AnnouncementTopic, AnnouncementTranslation} from './announcement.model';

import {IconId} from '../../../../shared/components/icon/icon.types';
/** Pořadí sekcí na stránce „Co je nového“. */
export const ANNOUNCEMENT_CATEGORIES: readonly AnnouncementCategory[] = ['important', 'news', 'tips'];

/** Jediné místo, kde se kategorie mapuje na ikonu — dřív zvlášť ve stránce i v dlaždici. */
export const ANNOUNCEMENT_CATEGORY_ICONS: Record<AnnouncementCategory, string> = {
    important: 'app:error',
    news: 'ph:newspaper',
    tips: 'ph:lightbulb',
};

/**
 * Téma novinky → ikona. Ikony jsou ZÁMĚRNĚ ty samé, které nese odpovídající položka
 * v levém menu (`menu.model.ts`) — uživatel tak u novinky vidí symbol funkce, kterou
 * už z navigace zná. Při přidání tématu doplň i klíč `whats-new.topic.<key>` do cs.json
 * a řádek do tools/announcements/README.md.
 */
export const ANNOUNCEMENT_TOPIC_ICONS: Record<AnnouncementTopic, IconId> = {
    chats: 'app:chats',
    recipes: 'app:recipes',
    presentations: 'app:presentations',
    copywriting: 'app:copywriting',
    images: 'app:images',
    audio: 'app:audio',
    documents: 'app:documents',
    social: 'app:social',
    translator: 'app:translator',
    paraphraser: 'app:paraphraser',
    detector: 'app:aiDetector',
    integrations: 'app:integrations',
    personalization: 'app:personalization',
    subscription: 'app:subscription',
    offer: 'ph:tag',
    other: 'app:info',
};

export const DEFAULT_ANNOUNCEMENT_TOPIC: AnnouncementTopic = 'other';

/** Téma dokumentu, s fallbackem na 'other' pro starší i neznámé hodnoty z BE. */
export function announcementTopic(announcement: AnnouncementDto): AnnouncementTopic {
    const topic = announcement.topic as AnnouncementTopic | undefined;
    return topic && topic in ANNOUNCEMENT_TOPIC_ICONS ? topic : DEFAULT_ANNOUNCEMENT_TOPIC;
}

/**
 * Překlad pro daný jazyk, s fallbackem na češtinu a pak na cokoli, co dokument nese.
 * Dřív existovalo ve třech kopiích (stránka, dlaždice, detail modal).
 */
export function resolveTranslation(announcement: AnnouncementDto, langCode: string): AnnouncementTranslation | undefined {
    const translations = announcement.translations ?? {};
    return translations[langCode] ?? translations['cs'] ?? Object.values(translations)[0];
}

export function announcementTitle(announcement: AnnouncementDto, langCode: string): string {
    return resolveTranslation(announcement, langCode)?.title ?? '';
}

/** Perex do seznamu. Dokumenty publikovane pred zavedenim pole vraci prazdny retezec. */
export function announcementExcerpt(announcement: AnnouncementDto, langCode: string): string {
    return resolveTranslation(announcement, langCode)?.excerpt ?? '';
}

/**
 * Nejnovější první. BE vrací `findAll()` bez řazení a FE dřív neřadil taky —
 * „poslední 3“ na dashboardu tedy znamenaly „3 v pořadí, jak je vrátilo Mongo“.
 */
export function sortByPublishedDesc(announcements: AnnouncementDto[]): AnnouncementDto[] {
    return [...announcements].sort(
        (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
    );
}
